



import React from "react";
import { FaPhoneAlt, FaWhatsapp, FaQuoteRight } from "react-icons/fa";

export default function DownloadAppAmruta({
  brand = "Amruta Travels",
  headingTagline = "Get in Touch",
  headingTitle = (
    <>
      Book <span className="text-brand">{brand}</span> <br />
      Cabs Online
    </>
  ),
  description =
    "Whether you're heading to the airport, planning an outstation trip, or need a daily office commute, Amruta Travels offers clean, premium cars, professional drivers, and transparent pricing. Reach us on call or WhatsApp for instant quotes.",
  bgUrl = "/images/shapes/download-app-bg-2-1.png",
  mainImage = "/images/bookingg.png",
  phone = "+91 8010014995",
  whatsapp = "+91 8010014995",
  quoteHref = "",
}) {
  const telHref = `tel:${phone.replace(/\s+/g, "")}`;
  const waHref = `https://wa.me/${whatsapp.replace(/\D/g, "")}`;

  return (
    <section
      className="download-app-three section-space"
      style={{ position: "relative", overflow: "hidden" }}
    >
      {/* Background */}
      <div
        className="download-app-three__bg"
        style={{
          backgroundImage: `url(${bgUrl})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          opacity: 0.15,
          position: "absolute",
          inset: 0,
        }}
      />

      <div className="container position-relative">
        <div className="row align-items-center">
          {/* Left content */}
          <div className="col-lg-6 col-md-7">
            <div className="sec-title mb-4">
              <div className="sec-title__top mb-2">
                <h6 className="sec-title__tagline text-uppercase text-brand fw-bold">
                  {headingTagline}
                </h6>
              </div>
              <h2 className="sec-title__title fw-bold mb-3">{headingTitle}</h2>
              <p className="text-white">{description}</p>
            </div>

            {/* Buttons */}
            <div className="d-flex flex-wrap gap-3 mt-4">
              <a href={telHref} className="download-app-three__btn btn-main">
                <FaPhoneAlt size={22} className="me-2 text-brand" />
                <div>
                  <strong>Call Now</strong>
                  <div className="small">{phone}</div>
                </div>
              </a>

              <a
                href={waHref}
                target="_blank"
                rel="noreferrer"
                className="download-app-three__btn btn-main"
              >
                <FaWhatsapp size={22} className="me-2 text-success" />
                <div>
                  <strong>Chat on WhatsApp</strong>
                  <div className="small">Instant reply</div>
                </div>
              </a>

              <a href={quoteHref} className="download-app-three__btn btn-main">
                <FaQuoteRight size={22} className="me-2 text-brand" />
                <div>
                  <strong>Get a Quote</strong>
                  <div className="small">Pune & Outstation</div>
                </div>
              </a>
            </div>
          </div>

          {/* Right-side Image */}
          <div className="col-lg-6 col-md-5 text-center mt-5 mt-md-0">
            <div
              style={{
                backgroundColor: "#eaf4fb",
                // borderRadius: "50%",
                // width: "420px",
                height: "420px",
                margin: "0 auto",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 0 40px rgba(0,0,0,0.1)",
              }}
            >
              <img
                src={mainImage}
                alt={`${brand} van`}
                style={{
                  width: "85%",
                  borderRadius: "20px",
                  objectFit: "contain",
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
